import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { Box, Grid } from 'transfix-ui/core'
import { BooleanParam } from 'use-query-params'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { ResponsiveLayout } from 'apps/fleet-planner/components/layout/ResponsiveLayout'
import { IRateConfirmationParams } from 'apps/fleet-planner/types/mobileApp'
import { useQueryParams } from 'utils/hooks'

const CarrierProfilesPageDesktopWrapper: FC = ({ children }) => {
  return (
    <Grid container justifyContent='center'>
      <Grid item xs={11} lg={10} xl={8}>
        {children}
      </Grid>
    </Grid>
  )
}

const CarrierProfilesPageMobileWrapper: FC = ({ children }) => {
  const history = useHistory()
  const backButtonHandler = () => history.push('/user/settings/general')
  return (
    <ResponsiveLayout title='Carrier Profiles' onPressBackButton={backButtonHandler}>
      <Box px={2} pb={2}>
        {children}
      </Box>
    </ResponsiveLayout>
  )
}

export const CarrierProfilesPageWrapper: FC = ({ children }) => {
  const { isMobile: isMobileOnBrowser } = useBreakpointContext()
  const [{ mobileApp: isFromApp }] = useQueryParams<IRateConfirmationParams>({
    mobileApp: BooleanParam,
  })
  const showMobileWrapper = isMobileOnBrowser && !isFromApp

  const Wrapper = showMobileWrapper
    ? CarrierProfilesPageMobileWrapper
    : CarrierProfilesPageDesktopWrapper
  return <Wrapper>{children}</Wrapper>
}
